import { CollectionsAPI } from '@weave/schema-gen-ts/dist/schemas/payments-integration/collections/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCollectionsV1Service = bindHTTP(CollectionsAPI);
export const serviceName = 'collections-v1' as const;
